module.exports = __webpack_public_path__ + "static/media/person-jumping.38d312f2.jpg";